// import { NativeDateAdapter } from '@angular/material/core';



// // import { NativeDateAdapter } from "@angular/material";

// const SUPPORTS_INTL_API = typeof Intl !== 'undefined';



// export class DateFormat extends NativeDateAdapter {

// useUtcForDisplay = true;

// parse(value: any): Date | null {

// if (typeof value === 'string' && value.indexOf('/') > -1) {

// const str = value.split('/');

// const year = Number(str[2]);

// const month = Number(str[1]) - 1;

// const date = Number(str[0]);

// return new Date(year, month, date);

// }

// const timestamp = typeof value === 'number' ? value : Date.parse(value);

// return isNaN(timestamp) ? null : new Date(timestamp);

// }

// }


import { NativeDateAdapter } from "@angular/material/core";

export class DateFormat extends NativeDateAdapter {
  useUtcForDisplay = true;

  // Parse input (DD/MM/YYYY) -> Date object
  parse(value: any): Date | null {
    if (typeof value === "string" && value.indexOf("/") > -1) {
      const str = value.split("/");
      const day = Number(str[0]);
      const month = Number(str[1]) - 1;
      const year = Number(str[2]);
      return new Date(year, month, day);
    }
    const timestamp = typeof value === "number" ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }

  // Format Date -> DD/MM/YYYY
  format(date: Date, displayFormat: any): string {
    if (!date) return '';
    const day = this._to2digit(date.getDate());
    const month = this._to2digit(date.getMonth() + 1);
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  private _to2digit(n: number) {
    return ('00' + n).slice(-2);
  }
}

// Global date formats
export const MY_DATE_FORMATS = {
  parse: { dateInput: 'DD/MM/YYYY' },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
